import React from 'react'
import { Col, Form, Image, Row } from 'react-bootstrap'
import { Checkbox } from 'antd'
import styled from 'styled-components'
import ImgCheckbox from '../../../../images/checkbox.svg'
import moment from 'moment'

export default function StapPage5To2({ step, createDate }) {
  const detail = step?.result ?? []
  const approve = step?.approve

  return (
    <>
      <Col xl={12}>
        <Checkbox.Group
          style={{
            width: '100%'
          }}
        >
          <Row>
            {/* IT Asset : ประเภทของคอมพิวเตอร์ */}
            <Col xl={12}>
              <>
                <div className="fw-bold mt-1 mb-2 ">
                  {detail.length > 0 && detail[0].equip_pd_group}
                </div>
                <CheckboxCustom className="fw-light">
                  {detail.length > 1 &&
                    detail[0].groups &&
                    detail[0].groups.length > 0 &&
                    detail[0].groups
                      .sort((a, b) => a.id - b.id)
                      .map((d, i) => (
                        <Form.Check
                          readOnly
                          checked={d.is_check === 1 ? true : false}
                          key={`${d.equip_pd_name}-${i}`}
                          label={d.equip_pd_name}
                          name={`description`}
                          className="mb-3"
                          type="checkbox"
                        />
                      ))}
                </CheckboxCustom>
              </>
              {/* IT Asset : เครื่องคอมพิวเตอร์ */}
              <>
                <p className="mt-4 fw-bold">
                  {' '}
                  {detail.length > 1 && detail[1].equip_pd_group}
                </p>
                <CheckboxRadioCustom className="fw-light">
                  {detail.length > 1 &&
                    detail[1].groups &&
                    detail[1].groups.length > 1 &&
                    detail[1].groups.map((d, i) => (
                      <>
                        <Form.Check
                          key={`dataDetail-2-${i}`}
                          inline
                          readOnly
                          checked={d.is_check === 1 ? true : false}
                          value={d.id}
                          label={d.equip_pd_name}
                          name={`typeCom`}
                          type="checkbox"
                        />
                        {d.is_check === 1 ? (
                          <div className="m-5 mt-2 mb-2 ">
                            <Form.Control value={d.detail} disabled />
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    ))}
                </CheckboxRadioCustom>
              </>
            </Col>
          </Row>
        </Checkbox.Group>
      </Col>
      {approve && (
        <div className=" mt-5 font-small-2 d-flex justify-content-center ">
          <div style={{ width: 300 }}>
            <div className="d-flex justify-content-center">
              <Image width={250} fluid src={approve.url} />
            </div>
            <div className="d-flex justify-content-center">
              ลงชื่อ
              <div
                style={{
                  borderBottom: '1px dashed rgb(135, 135, 135)',
                  width: 200
                }}
              ></div>{' '}
              ผู้ดำเนินการ
            </div>
            <div className="d-flex justify-content-center mt-3">
              ({approve.title_th} {approve.name_th} {approve.surname_th})
            </div>
            <div className="d-flex justify-content-center fw-light mt-1">
              {approve.position_th}
            </div>
            <div className="d-flex justify-content-center fw-light">
              {moment(approve.confirm_date5).format('DD/MM/YYYY')}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const CheckboxRadioCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 1rem;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: 'var(--comp-badge-color-background-primary)' !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid 'var(--comp-badge-color-background-primary)';
  }
  label {
    margin: 0em 0em 0em 1em;
  }
  .form-check .form-check-input {
    float: left;
    margin-left: 0em;
  }
`

const CheckboxCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 4px !important;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: 'var(--comp-badge-color-background-primary)' !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid 'var(--comp-badge-color-background-primary)';
  }
  label {
    margin: 0em 0em 0em 1em;
  }
  .form-check .form-check-input {
    float: left;
    margin-left: 0em;
    margin-top: 0em;
  }
`
